export const disallowedKeys = new Set();
disallowedKeys.add('__proto__');
disallowedKeys.add('prototype');
disallowedKeys.add('constructor');
